export function youtubeId(value){
 try{
  const url=new URL(value.trim());
  if(!['https:'].includes(url.protocol))return null;
  const host=url.hostname.toLowerCase();
  const parts=url.pathname.split('/').filter(Boolean);
  let id=null;
  if(['youtube.com','www.youtube.com','m.youtube.com'].includes(host)){
   if(parts[0]==='watch')id=url.searchParams.get('v');
   else if(['shorts','embed','live'].includes(parts[0]))id=parts[1];
  }else if(host==='youtu.be')id=parts[0];
  else if(host==='www.youtube-nocookie.com'&&parts[0]==='embed')id=parts[1];
  return /^[A-Za-z0-9_-]{11}$/.test(id||'')?id:null;
 }catch{return null;}
}
export function youtubeThumbnail(embedUrl){const id=youtubeId(embedUrl);return id?`https://i.ytimg.com/vi/${id}/hqdefault.jpg`:null;}
